import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";

import { getImageName } from "helpers";

import shareIcon from "/public/images/shareIcon.svg";

import OffreImage from "components/customImages/OffreImage";
import ShareStoreModal from "components/ui_components/ShareStoreModal";

type OfferCardProps = {
  offerImage: string;
  storeImage: string;
  storeName: string;
  storeSlug: string;
  categorySlug: string;
  publicationUrl: string;
  fromStore?: boolean;
};

function OfferCard({
  offerImage,
  storeImage,
  storeName,
  storeSlug,
  categorySlug,
  publicationUrl,
  fromStore = false,
}: OfferCardProps) {
  const { t: translate } = useTranslation("offers");
  const [isShareModalOpen, setIsShareModalOpen] = useState<boolean>(false);

  if (!storeSlug || !categorySlug || !storeName) {
    return null;
  }

  function openShareModal() {
    setIsShareModalOpen(true);
  }
  function closeShareModal() {
    setIsShareModalOpen(false);
  }
  return (
    <div className="border border-gray-300 rounded-[29px]  relative  ">
      {/* shareModal */}
      {isShareModalOpen && (
        <ShareStoreModal
          closeShareModal={closeShareModal}
          storeSlug={storeSlug}
          categorySlug={categorySlug}
        />
      )}
      {/* shareIcon */}
      <Image
        onClick={openShareModal}
        src={shareIcon}
        width={50}
        height={50}
        alt="share icon"
        className="absolute ltr:right-2 rtl:left-2 rtl:rotate-[270deg] top-2 z-10 shadow-backgroundGrey drop-shadow-xl cursor-pointer "
      />
      <Link
        href={
          fromStore
            ? publicationUrl
            : {
                pathname: "/categories/[category]/[id]",
                query: { category: categorySlug, id: storeSlug },
              }
        }
        target={fromStore ? "_blank" : "_self"}
        className="block"
      >
        <OffreImage
          imageName={getImageName(offerImage)}
          className={
            "w-full rounded-t-[29px] object-contain cursor-pointer hover:opacity-90 transition-opacity"
          }
          alt={translate("imageNotFound")}
        />
      </Link>

      <div className="flex items-center gap-4 p-4">
        <Image
          src={storeImage || ""}
          alt="Store Image"
          width={50}
          height={50}
          className="rounded-full mr-2"
        />
        <Link
          id="affar_link_btn"
          href={{
            pathname: "/categories/[category]/[id]",
            query: { category: categorySlug, id: storeSlug },
          }}
          passHref
          className="font-semibold text-xs lg:text-base break-words whitespace-normal hover:underline "
        >
          {storeName?.split("_").join(" ")}
        </Link>
      </div>
    </div>
  );
}

export default OfferCard;
